import parentPath from '../path'

export default `${parentPath}/subscriptions`
